var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgQrcode = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 134,
    viewBox: "0 0 134 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333344 0.451721H50.3333V50.4517H0.333344V0.451721ZM133.667 0.451721V50.4517H83.6667V0.451721H133.667ZM83.6667 92.1184H100.333V75.4517H83.6667V58.7851H100.333V75.4517H117V58.7851H133.667V75.4517H117V92.1184H133.667V117.118H117V133.785H100.333V117.118H75.3333V133.785H58.6667V100.452H83.6667V92.1184ZM100.333 92.1184V117.118H117V92.1184H100.333ZM0.333344 133.785V83.7851H50.3333V133.785H0.333344ZM17 17.1184V33.7851H33.6667V17.1184H17ZM100.333 17.1184V33.7851H117V17.1184H100.333ZM17 100.452V117.118H33.6667V100.452H17ZM0.333344 58.7851H17V75.4517H0.333344V58.7851ZM42 58.7851H75.3333V92.1184H58.6667V75.4517H42V58.7851ZM58.6667 17.1184H75.3333V50.4517H58.6667V17.1184Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQrcode);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/qrcode.8e13963f021ea6ae5f8eeb37637e8b43.svg";